import styled from 'styled-components'

import {Accordion} from '~/components/general/accordion/Accordion'

export const StyledAccordion = styled(Accordion)`
  margin-bottom: ${({theme}) => theme.spacing.md};
`
